var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viweBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55 105A50 50 0 1 0 55 5a50 50 0 0 0 0 100Z",
    fill: "#FFDA7C",
    stroke: "#fff",
    strokeWidth: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 33.4c3.3 3.3 5 7 5 11a9.2 9.2 0 0 1-5.5 8.9v.5l2 1.5c.8.7 1.6 1.4 2.2 2.3 1.6 1.9 2.4 4.2 2.3 6.7A15.7 15.7 0 0 1 68 76.6a20.7 20.7 0 0 1-14 5c-5.6 0-10.3-1.7-14-5a17.5 17.5 0 0 1-4.5-6.8l-.2-.7c-.4-1.2-.7-2.5-.7-3.8 0-2.7 2.3-4 6.8-4 1.9 0 3.1.2 3.7.7.8.6 1.5 1.8 2.1 3.6.5 1.5 1.8 2.6 3.9 3.4 1 .3 2 .4 3 .4 2.4 0 4.2-.5 5.4-1.5a4.4 4.4 0 0 0 1.8-3.4 4.3 4.3 0 0 0-1.8-3.3 6.1 6.1 0 0 0-4-1.5l-3.2-.1c-.7-.1-1.3-.4-1.8-.7-1.3-.6-2-2.4-2-5.4 0-3.3 1-5.2 2.7-5.8a14 14 0 0 1 3.6-.4c3.6 0 5.3-.9 5.3-2.7a3.9 3.9 0 0 0-1.4-2.8c-1-1-2.4-1.4-3.9-1.3a8 8 0 0 0-4 .8A4 4 0 0 0 49 43l-.5.8c-1 2.4-2.6 3.5-4.6 3.5-1.4 0-2.7-.5-3.8-1.2-2.4-1.4-3.5-3-3.5-4.7 0-.8.5-2.4 1.6-4.8.4-.8 1-1.5 1.5-2.2.9-1 1.8-2 3-2.8a21 21 0 0 1 11.2-3.2c5.7 0 10.2 1.7 13.6 5Z",
    fill: "#F36A7D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.fe23eab5d852e05f37c0fe8eee5bbebe.svg";
export { ForwardRef as ReactComponent };